// Custom for ja-faq.liquid

document.addEventListener("DOMContentLoaded", function() {
    const jaFaqDetails = document.querySelectorAll('.ja-faq-container details');
  
    jaFaqDetails.forEach((detail) => {
      const summary = detail.querySelector('summary');
      const iconMinus = summary.querySelector('.ja-icon-minus');
      const iconPlus = summary.querySelector('.ja-icon-plus');
  
      // Initialize: Set the correct icon based on the 'open' attribute
      if (detail.hasAttribute('open')) {
        iconMinus.style.display = 'inline';
        iconPlus.style.display = 'none';
      } else {
        iconMinus.style.display = 'none';
        iconPlus.style.display = 'inline';
      }
  
      summary.addEventListener('click', function(event) {
        // Prevent the default behavior to manually control the 'open' attribute
        event.preventDefault();
  
        if (detail.hasAttribute('open')) {
          detail.removeAttribute('open');
          iconMinus.style.display = 'none';
          iconPlus.style.display = 'inline';
        } else {
          detail.setAttribute('open', '');
          iconMinus.style.display = 'inline';
          iconPlus.style.display = 'none';
        }
      });
  
      // For better accessibility
      summary.addEventListener('keypress', function(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          summary.click();
        }
      });
    });
  });

// Custom for ja-accordion-tabs.liquid (Mobile accordion version)
if (document.querySelector('.ja-accordion-container')) {

  document.addEventListener("DOMContentLoaded", function() {
      const jaAccordionButtons = document.querySelectorAll('.ja-accordion-container .ja-acc-button');
      const jaAccordionContents = document.querySelectorAll('.ja-accordion-container .ja-acc-content');

      // Add 'ja-active' class to the first button and content to keep it open initially
      jaAccordionButtons[0].classList.add('ja-active');
      jaAccordionContents[0].classList.add('ja-active');

      jaAccordionButtons.forEach(button => {
          const jaAccordionIconMinus = button.querySelector('.ja-icon-minus');
          const jaAccordionIconPlus = button.querySelector('.ja-icon-plus');

          button.addEventListener('click', function() {
              const targetId = this.getAttribute('data-target');
              const targetContent = document.getElementById(targetId);

              // Toggle active class for the clicked button and corresponding content
              this.classList.toggle('ja-active');
              if (targetContent) {
                  targetContent.classList.toggle('ja-active');
              }

              // Update icons for all buttons
              jaAccordionButtons.forEach(btn => {
                  const btnIconMinus = btn.querySelector('.ja-icon-minus');
                  const btnIconPlus = btn.querySelector('.ja-icon-plus');
                  if (btnIconMinus && btnIconPlus) {
                      btnIconMinus.style.display = btn.classList.contains('ja-active') ? 'inline' : 'none';
                      btnIconPlus.style.display = btn.classList.contains('ja-active') ? 'none' : 'inline';
                  }
              });

              // Update icons for the clicked button
              if (jaAccordionIconMinus && jaAccordionIconPlus) {
                  jaAccordionIconMinus.style.display = this.classList.contains('ja-active') ? 'inline' : 'none';
                  jaAccordionIconPlus.style.display = this.classList.contains('ja-active') ? 'none' : 'inline';
              }
          });
      });
  });
}


// Custom for ja-accordion-tabs.liquid (Desktop tabs version)
if (document.querySelector('.ja-tabs-container')) {
    document.addEventListener("DOMContentLoaded", function() {
      const jaTablinks = document.querySelectorAll('.ja-tablinks');
      const jaTabcontent = document.querySelectorAll('.ja-tabcontent');
    
      // Initialize the first tab
      if (jaTablinks.length > 0 && jaTabcontent.length > 0) {
        jaTablinks[0].setAttribute('aria-selected', 'true');
        jaTablinks[0].classList.add('ja-active-tab');
        jaTabcontent[0].removeAttribute('hidden');
      }
    
      jaTablinks.forEach((tab, index) => {
        tab.addEventListener('click', function(event) {
          // Reset all tabs and tab content
          jaTablinks.forEach(t => {
            t.setAttribute('aria-selected', 'false');
            t.classList.remove('ja-active-tab');
          });
          jaTabcontent.forEach(c => {
            c.setAttribute('hidden', 'true');
          });
    
          // Activate the clicked tab and reveal its content
          const targetId = this.getAttribute('aria-controls');
          const targetContent = document.getElementById(targetId);
    
          if (targetContent) {
            this.setAttribute('aria-selected', 'true');
            this.classList.add('ja-active-tab');
            targetContent.removeAttribute('hidden');
          }
        });
      });
    });
  }

// c-product-variant-options.liquid

document.addEventListener('DOMContentLoaded', function() {
  // Get all radio inputs with the class 'c-radio-input'
  const cRadioInputs = document.querySelectorAll('.c-radio-input');
  
  cRadioInputs.forEach(function(cRadioInput) {
    cRadioInput.addEventListener('change', function(event) {
      // Find the parent container that holds both radio and label. Adjust the selector based on your HTML structure.
      const cContainer = event.target.closest('.product-form__input');
      
      // Hide all checkmarks in this container
      const cRadioCheckmarks = cContainer.querySelectorAll('.c-radio-checkmark');
      cRadioCheckmarks.forEach(function(cRadioCheckmark) {
        cRadioCheckmark.style.display = 'none';
      });
      
      // Show the checkmark next to the selected radio button
      const cSelectedLabel = cContainer.querySelector(`label[for="${event.target.id}"]`);
      const cSelectedCheckmark = cSelectedLabel.querySelector('.c-radio-checkmark');
      cSelectedCheckmark.style.display = 'flex'; // or 'inline', 'block', whatever suits your design
    });
  });
});